const templateUrl = require('./shipment-pricing.html');

const app = angular.module('msi.shipments.shipmentPricing', []);

app.component('ogShipmentPricing', {
  bindings: {
    shipment: '<ogFor'
  },
  templateUrl: templateUrl,
  controller: 'ShipmentController'
});

module.exports = app.name;
